
export default {
  setSearch(state, search) {
    state.search = search;
  },
  setDepartments(state, departments) {
    state.departments = departments;
  },
  setPersons(state, persons) {
    state.persons = persons;
  },
  setDepartmentPersonDictionary(state, departmentPersonDictionary) {
    state.departmentPersonDictionary = departmentPersonDictionary;
  },
  setAbstractAddCountByDepartment(state, result) {
    state.abstractAddCountByDepartment = result;
  },
  setAbstractClickCountByDepartment(state, result) {
    state.abstractClickCountByDepartment = result;
  },
  setAbstractHotByDepartment(state, result) {
    state.abstractHotByDepartment = result;
  },
  setAbstractAddCountByUser(state, result) {
    state.abstractAddCountByUser = result;
  },
  setUserClickCount(state, result) {
    state.userClickCount = result;
  },
  setAbstractHot(state, result) {
    state.abstractHot = result;
  },
  setWordByQueryCount(state, result) {
    state.wordByQueryCount = result;
  },
  setKeywordByQueryCount(state, result) {
    state.keywordByQueryCount = result;
  },
}